module.exports = __webpack_public_path__ + "static/media/virus-hr-considerations.72ef00fb.png";